import { h } from '@stencil/core';

interface Rating {
  rating: number;
  size: 'sm' | 'md' | 'lg';
  text?: string;
  boxColor?: 'good' | 'bad' | 'regular';
  textColor?: 'green' | 'red' | 'orange';
}

export default function Rating({ rating, size, text, boxColor, textColor }: Rating) {
  const hasBoxColor = typeof boxColor !== 'undefined';
  const hasTextColor = typeof textColor !== 'undefined';

  const ratingBoxColorClass = hasBoxColor ? '-'.concat(boxColor!) : rating <= 4.9 ? '-bad' : rating >= 7 ? '-good' : '-regular';

  const ratingTextColorClass = hasTextColor ? '-'.concat(textColor!) : rating <= 4.9 ? '-red' : rating >= 7 ? '-green' : '-orange';

  const hasText = typeof text !== 'undefined';
  return (
    <div class="reviews -eva-3-valign">
      <div class={`eva-3-rating ${ratingBoxColorClass} -${size}`}>
        <span class="rating-text">{rating}</span>
      </div>
      {hasText && <span class={`-eva-3-tc${ratingTextColorClass}-3 -eva-3-ml-xsm`}>{text}</span>}
    </div>
  );
}
